<template>
  <div
    :class="['seccion-titular', 'mt-n14', classCat(CodigoCat)]"
    v-if="$vuetify.breakpoint.width > 960"
  >
    <div :class="['myconteiner']">
      <h1 :class="['heading-14', 'text-center']">
        {{ nombreCat(CodigoCat) }}
      </h1>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  name: "TituloCat",
  props: {
    CodigoCat: 0,
    NombreCat: "",
  },

  created() {
    if (this.$route.name === "Subcat") this.CLR_BUSCARSCAT();
  },
  computed: {
    ...mapState(["filter", "SubCategorias", "maestro"]),
    IdSubcat() {
      let xidscat = 0;

      this.filter.codscat.length === 0
        ? (xidscat = JSON.parse(window.localStorage.getItem("subcat")))
        : (xidscat = this.filter.codscat);
      return xidscat;
    },
    subCatItem: function () {
      //
      return function (id) {
        if (Object.entries(this.maestro).length !== 0)
          return this.maestro.ttSubCategoria
            .filter((x) => x.Categoria === id)
            .map((x) => x.Items)
            .toString();
      };
    },

    nombreCat: function () {
      //
      return function (id) {
        if (Object.entries(this.maestro).length !== 0)
          return this.maestro.ttCategoria
            .filter((x) => x.Categoria === id)
            .map((x) => x.Nombre)
            .toString();
      };
    },
  },
  methods: {
    ...mapMutations(["CLR_BUSCARSCAT"]),
    classCat(idCat) {
      if (idCat === 10) {
        return "ceramicos";
      } else if (idCat === 15) {
        return "banos";
      } else {
        return "resultado-busqueda";
      }
    },
  },
};
</script>

<style scoped>
.seccion-titular {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 40vh;
  max-height: none;
  margin-top: 30px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-position: 0px 0px, 50% 50%;
  background-size: auto, cover;
  background-repeat: repeat, no-repeat;
}

.seccion-titular.resultado-busqueda {
  background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(rgba(124, 38, 41, 0.47)),
      to(rgba(124, 38, 41, 0.47))
    ),
    url("https://www.domosadecoraciones.com/images/Categorias/titulo/0_ceramicos.jpg");
  background-image: linear-gradient(180deg),
    url("https://www.domosadecoraciones.com/images/Categorias/titulo/0_ceramicos.jpg");
  background-position: 0px 0px, 50% 50%;
}

.seccion-titular.ceramicos {
  max-width: none;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(rgba(124, 38, 41, 0.40)),
      to(rgba(211,188,141,0.30))
    ),
    url("https://www.domosadecoraciones.com/images/Categorias/titulo/10_ceramicos.jpg");
  background-image: 
    url("https://www.domosadecoraciones.com/images/Categorias/titulo/10_ceramicos.jpg");
}
.seccion-titular.banos {
  max-width: none;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(rgba(124, 38, 41, 0.40)),
      to(rgba(211,188,141,0.30))
    ),
    url("https://www.domosadecoraciones.com/images/Categorias/titulo/15_banos.jpg");
  background-image: 
    url("https://www.domosadecoraciones.com/images/Categorias/titulo/15_banos.jpg");
}

.myconteiner {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  max-width: 1140px;
  margin-top: 0px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 0px;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.heading-14 {
  margin-top: 76px;
  padding: 23px;
  border-style: solid;
  border-width: 5px;
  border-color: #d3bc8d;
  background-color: #7c2629;
  box-shadow: -4px 4px 10px 0 rgba(49, 27, 17, 0.79);
  font-family: Roboto, sans-serif;
  color: #fff;
}

@media screen and (max-width: 991px) {
  .myconteiner {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

@media screen and (max-width: 479px) {
  .seccion-titular {
    width: 100%;
    height: 40vh;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .myconteiner {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 90%;
    margin-right: auto;
    margin-left: auto;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }

  .myconteiner.plantas {
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .heading-14 {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 300px;
    margin-top: 89px;
    padding: 11px 16px;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 25px;
    line-height: 35px;
    text-align: center;
    color: #fff;
  }
}
</style>
